import React, { useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import styles from "./toc.module.css"
import cn from "classnames"

const Toc = props => {
  const data = useStaticQuery(graphql`
    query {
      markdownRemark {
        tableOfContents(absolute: false)
      }
    }
  `)
  const { isOpen, setDrawer } = props
  const { markdownRemark } = data
  const { tableOfContents } = markdownRemark

  useEffect(() => {
    window.addEventListener(
      "hashchange",
      () => {
        setDrawer(false)
      },
      false
    )
  }, [])

  return (
    <div
      className={cn(styles.container, isOpen ? styles["on"] : styles["off"])}
    >
      <div
        className={styles.tocs}
        dangerouslySetInnerHTML={{ __html: tableOfContents }}
      />
      <div
        className={cn(styles.trigger, isOpen ? styles["on"] : styles["off"])}
        onClick={() => {
          setDrawer(false)
        }}
      >
        |
      </div>
    </div>
  )
}

export default Toc
